import { Component, ComponentInterface, Element, h, Host, Prop } from "@stencil/core";

/**
 * This component is intended to be used as a child of the ux-input component.
 */
@Component({
    tag: "ux-unit",
    styleUrl: "unit.scss",
    shadow: true
})
export class Unit implements ComponentInterface {
    /**
     * The host element for the `Unit` component.
     */
    @Element() host: HTMLUxUnitElement;

    /**
     * The unit of measurement to be displayed
     */
    @Prop() readonly unit: string = "";

    render() {
        return <Host>{this.unit}</Host>;
    }
}
